import { Suspense, lazy, useEffect, useState } from "react";
import { videos, mobileVideos } from "./lib/variables";
import Loading from "./components/Loading";

const Mobile = lazy(() => import("./container/Mobile"));
const Desktop = lazy(() => import("./container/Desktop"));

const App = () => {
  const [videoURIs, setVideoURIs] = useState([]);

  useEffect(() => {
    // console.log(window.matchMedia('(min-width: 768px)').matches);

    const prefetchVideos = async () => {
      setVideoURIs([]);

      const url = (index) =>
        window.matchMedia("(min-width: 768px)").matches
          ? `https://assets.stromdev.dk/clips/${(index + 1)
              .toString()
              .padStart(3, 0)}encoded.mp4`
          : `https://assets.stromdev.dk/clips/mobile/new/${(index + 1)
              .toString()
              .padStart(3, 0)}encoded-mobile-new.mp4`;

      const sources = window.matchMedia("(min-width: 768px)").matches
        ? videos
        : mobileVideos;

      const promises = sources.map(async (_, index) => {
        // console.log('_ i', _, index)
        const res = await fetch(url(index));
        const blob = await res.blob();
        const objectURL = URL.createObjectURL(blob);

        return objectURL;
      });

      const URIs = await Promise.all(promises);
      // console.log(URIs)

      setVideoURIs(URIs);
    };

    prefetchVideos();
  }, []);

  if (videoURIs.length < 1) return <Loading />;

  return (
    <>
      {window.matchMedia("(min-width: 768px)").matches ? (
        <Suspense fallback={<Loading />}>
          <Desktop videoURIs={videoURIs} />
        </Suspense>
      ) : (
        <Suspense fallback={<Loading />}>
          <Mobile videoURIs={videoURIs} />
        </Suspense>
      )}
    </>
  );
};

export default App;
